import React, { useState } from 'react'

function Onboarding({ onBaigta }) {
  const [ekranas, setEkranas]   = useState(1)
  const [fade, setFade]         = useState(false)
  const [klaida, setKlaida]     = useState(false)
  const [kraunasi, setKraunasi] = useState(false)

  function eiti_i_ekrana_2() {
    setFade(true)
    setTimeout(() => {
      setEkranas(2)
      setFade(false)
    }, 300)
  }

  async function prasitiGPS() {
    if (!navigator.geolocation) {
      setKlaida(true)
      return
    }
    setKraunasi(true)
    setKlaida(false)
    try {
      await new Promise((resolve, reject) => {
        const t = setTimeout(() => reject(new Error('timeout')), 8000)
        navigator.geolocation.getCurrentPosition(
          (p) => { clearTimeout(t); resolve(p) },
          (e) => { clearTimeout(t); reject(e) },
          { timeout: 8000, maximumAge: 60000 }
        )
      })
      onBaigta()
    } catch {
      setKlaida(true)
    } finally {
      setKraunasi(false)
    }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: '#141F1A',
      display: 'flex', flexDirection: 'column',
      justifyContent: 'center', alignItems: 'center',
      padding: '24px 32px',
      opacity: fade ? 0 : 1, transition: 'opacity 0.3s ease',
      zIndex: 9999,
    }}>

      {/* ── Ekranas 1 — Welcome ── */}
      {ekranas === 1 && (
        <div style={{ width: '100%', maxWidth: 390 }}>
          <p style={{
            fontFamily: 'Syne, sans-serif', fontSize: 11,
            color: '#8FA294', letterSpacing: '0.14em',
            textTransform: 'lowercase', marginBottom: 32,
          }}>
            kelionių · app
          </p>

          <h1 style={{
            fontFamily: 'Lora, serif', fontSize: 34, fontWeight: 500,
            color: '#F0E8D5', letterSpacing: '-0.02em',
            lineHeight: 1.2, marginBottom: 16,
          }}>
            Atrask Lietuvą{' '}
            <span style={{ color: '#E5A840', fontStyle: 'italic', fontWeight: 600 }}>
              aplink save
            </span>
          </h1>

          <p style={{
            fontFamily: 'Syne, sans-serif', fontSize: 15,
            color: '#B0B8A8', lineHeight: 1.6, marginBottom: 40,
          }}>
            Spontaniškai keliaudamas ar planuodamas savaitgalį — rask įdomias vietas 30 km spinduliu nuo tavęs
          </p>

          <button className="pagrindinis-mygtukas" onClick={eiti_i_ekrana_2}>
            Pradėti
          </button>

          <div style={{ width: 48, height: 2, background: '#E5A840', margin: '24px auto 0' }} />
        </div>
      )}

      {/* ── Ekranas 2 — GPS prašymas ── */}
      {ekranas === 2 && (
        <div style={{ width: '100%', maxWidth: 390 }}>
          <h1 style={{
            fontFamily: 'Lora, serif', fontSize: 26, fontWeight: 500,
            color: '#F0E8D5', letterSpacing: '-0.02em', marginBottom: 12,
          }}>
            Kur tu dabar?
          </h1>

          <p style={{
            fontFamily: 'Syne, sans-serif', fontSize: 15,
            color: '#B0B8A8', lineHeight: 1.6, marginBottom: 32,
          }}>
            Kad parodytumėm vietas aplink tave, reikia žinoti tavo poziciją
          </p>

          <button
            className="pagrindinis-mygtukas"
            onClick={prasitiGPS}
            disabled={kraunasi}
          >
            {kraunasi ? 'Kraunama...' : klaida ? 'Bandyti dar kartą' : 'Įjungti GPS'}
          </button>

          {klaida && (
            <>
              <p style={{
                marginTop: 12,
                fontFamily: 'Syne, sans-serif', fontSize: 12,
                color: '#C86353', textAlign: 'center', lineHeight: 1.5,
              }}>
                Nepavyko gauti GPS. Patikrink leidimą telefono nustatymuose ir bandyk dar kartą.
              </p>
              <button
                onClick={onBaigta}
                style={{
                  marginTop: 10, width: '100%', height: 44, borderRadius: 10,
                  background: 'transparent', color: '#F0E8D5', border: '1px solid #3A4C42',
                  fontFamily: 'Syne, sans-serif', fontSize: 13, fontWeight: 500, cursor: 'pointer',
                }}
              >
                Tęsti be GPS
              </button>
            </>
          )}

          <p style={{
            marginTop: 24,
            fontFamily: 'Syne, sans-serif', fontSize: 11,
            color: '#7A8A7E', textAlign: 'center', lineHeight: 1.5,
          }}>
            Pozicijos duomenų nesaugom — naudojama tik atstumui skaičiuoti
          </p>
        </div>
      )}

    </div>
  )
}

export default Onboarding
